export default "__VITE_ASSET__DKfOrBwZ__"